module.exports = __webpack_public_path__ + "site_static/img/data-2.ce55d3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneimg/data-2.jpg
// module id = Rb2a
// module chunks = 0